module.exports = __webpack_public_path__ + "img/travel_step3.2b7803ef.svg";